<template>
<div class="coverList">
  <nuxt-link :to="`${toPath}${item.id}?from=${Route.path}`" class="news" v-for="item in list" :key="item.id">
    <img class="cover" :src="getCoverImg(item)" v-if="getCoverImg(item)"/>
    <div v-if="!getCoverImg(item)" class="emptyCover">{{emptyTxt}}</div>
    <div class="content">
      <div class="head">
        <div class="title">{{item.newsTitle || item.contentTitle}}</div>
        <time v-if="item.createTime">{{ dayjs(item.createTime).format("YYYY-MM-DD") }}</time>
      </div>
      <div class="intro">{{item.newsContent || item.content}}</div>
      <div class="viewMore" text-data="查看更多">查看更多</div>
    </div>
  </nuxt-link>
</div>
</template>

<script setup>
import dayjs from "dayjs";
const FILE_HOST = import.meta.env.VITE_FILE_HOST
const Route = useRoute();

const props = defineProps({
  list: {
    required: true,
    type: Array
  },
  toPath: {
    required: true,
    type: String
  },
  emptyTxt: {
    type: String,
    default: ''
  }
})

function getCoverImg(item) {
  if (!item.newsTitleCover && !item.contentTitleCover) {
    return false
  }
  if (item.newsFormat === 1 || item.newsFormat === 3) {
    return FILE_HOST + item.newsTitleCover
  }
  if (item.contentFormat === 1 || item.contentFormat === 3) {
    return FILE_HOST + item.contentTitleCover
  }
  if(item.newsFormat === 2) {
    let _cover = item.newsTitleCover.split(",")
    return FILE_HOST + _cover[0]
  }
  if(item.contentFormat === 2) {
    let _cover = item.contentTitleCover.split(",")
    return FILE_HOST + _cover[0]
  }
  return false
}
</script>

<style scoped lang="scss">
.coverList {
  margin: 60px 0;
  > .news {
    display: flex;
    align-items: flex-start;
    background: rgba(166, 208, 233, 0.1);
    //width: 100%;
    padding: 10px 20px 15px 10px;
    cursor: pointer;
    text-decoration: none;
    margin-bottom: 3px;
    > img {
      width: 259px;
      height: 166px;
      margin-right: 22px;
      flex-shrink: 0;
    }
    > .content {
      padding-top: 14px;
      //padding-right: 40px;
      //height: 203px;
      position: relative;
      flex: 1;
      //color: var(--secondary-text-color);
      color: #333;
      overflow: hidden;
      .head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
          font-size: 18px;
          font-weight: 600;
          line-height: 26px;
          color: var(--title-text-color);
          width: 810px;
          //max-width: 900px;
          overflow: hidden;
          text-overflow: ellipsis; //文本溢出显示省略号
          white-space: nowrap; //文本不会换行
        }
        time {
          font-size: 16px;
          //margin: 20px 0;
          display: block;
        }
      }
      .intro {
        font-size: 16px;
        line-height: 1.5;
        //width: 1020px;
        max-width: 100%;
        overflow: hidden;
        text-align: justify-all;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 10px 0 34px;
        //display: -webkit-box;
        //-webkit-line-clamp: 2;
        //-webkit-box-orient: vertical;
      }
      .viewMore {
        position: relative;
        display: inline-block;
        border-radius: 25px;
        overflow: hidden;
        border: 1px solid var(--main-blue-color);
        font-size: 14px;
        text-align: center;
        padding: 0 25px;
        line-height: 36px;
        color: var(--main-blue-color);
        background: var(--white);
        &:after {
          background: var(--main-blue-color);
          width: 100%;
          height: 100%;
          content: "";
          display: inline-block;
          position: absolute;
          left: -100%;
          top: 0;
          transition: .5s all ease-in-out;
        }
      }
    }
    &:hover {
      background: var(--white);
      box-shadow: 8px 4px 38px 1px rgba(0, 10, 39, 0.1);
      > .content {
        .title {
          color: var(--main-blue-color);
        }
        .viewMore {
          color: var(--white);
          &:after {
            transition: .5s all ease-in-out;
            left: 0;
          }
          &:before {
            color: var(--white);
            content: attr(text-data);
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: 3;
            transition: .3s all ease-in-out;
          }
        }
      }
    }
    .emptyCover {
      background: url("../../assets/images/pages/public/emptyCover.png") no-repeat;
      width: 259px;
      height: 166px;
      background-size: 100% 100%;
      margin-right: 22px;
      font-size: 36px;
      color: var(--white);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      line-height: 1.2;
    }
  }
}
</style>